import fuzzyHighlight from '@jetbrains/ring-ui/components/global/fuzzy-highlight'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import PopupMenu from '@jetbrains/ring-ui/components/popup-menu/popup-menu'
import {useRef, useState} from 'react'

import {useWidthResizeObserver} from '../../../../../../../../../hooks/useResizeObserver'
import Highlight from '../../../../../../../../common/Highlight/Highlight'
import {Size} from '../../../../../../components/Input'
import Input from '../../../../../../components/Input/Input'

import type {PipelineRepositoryBranchProps} from './PipelineRepositoryBranch.types'

import styles from './PipelineRepositoryBranch.css'

function PipelineRepositoryBranch({
  onChange,
  branches,
  value,
  ...restProps
}: PipelineRepositoryBranchProps) {
  const values = value.split(',')
  const search = values.pop()!
  const matchedBranches =
    branches
      ?.map(branch => {
        const name = `${branch.label}` ?? ''
        const match =
          search.length > 0 ? fuzzyHighlight(search, name) : {matched: true, matches: []}
        return {
          name,
          ...match,
        }
      })
      .filter(item => item.matched && !values.includes(item.name)) ?? []

  const [lastInsertedValue, setLastInsertedValue] = useState<string | null>()
  const [showPopup, setShowPopup] = useState(false)
  const inputRef = useRef<HTMLTextAreaElement>(null)
  const popupRef = useRef<PopupMenu>(null)
  const [containerWidth, containerRef] = useWidthResizeObserver()

  return (
    <div className={styles.inputContainer} ref={containerRef}>
      <Input
        multiline
        inputClassName={'ring-js-shortcuts'}
        size={Size.FULL}
        onFocus={() => setShowPopup(true)}
        onBlur={e => {
          if (!popupRef.current?.container?.contains(e.relatedTarget)) {
            setShowPopup(false)
          }
        }}
        value={value}
        onChange={e => {
          onChange(e.currentTarget.value)
          setLastInsertedValue(null)
          setShowPopup(true)
        }}
        inputRef={inputRef}
        {...restProps}
      />
      <PopupMenu
        className={styles.popup}
        ref={popupRef}
        directions={[Directions.BOTTOM_CENTER]}
        hidden={!showPopup || matchedBranches.length === 0 || search === lastInsertedValue}
        onCloseAttempt={() => setShowPopup(false)}
        closeOnSelect
        maxHeight={-1}
        activateFirstItem
        data={matchedBranches.map(({name, matches}) => ({
          key: name,
          label: <Highlight string={name} matches={matches} />,
        }))}
        onSelect={({key}) => {
          const name = String(key)
          setLastInsertedValue(name)
          onChange((search.length > 0 ? value.slice(0, -search.length) : value) + name)
          inputRef.current?.focus()
        }}
        style={{
          width: containerWidth,
        }}
        renderOptimization
      />
    </div>
  )
}

export default PipelineRepositoryBranch
